import React, { Component } from 'react';
import '../../../src/styles/Home.css';
import '../../../src/styles/Login.css';
import { FaChevronDown } from 'react-icons/fa';
import { Accordion } from 'react-bootstrap';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { userService } from '../../_services';
import DocumentMeta from 'react-document-meta';
import { Redirect, Route } from 'react-router-dom';

export class ForgotPassword extends Component {
    displayName = ForgotPassword.name
    constructor(props) {
        super(props);
        this.state = {          
            message: "",
            redirectToLogin: false,
            errors: {},
            username: ''
        };
        this.ResetPassword = this.ResetPassword.bind(this);
        this.handleChange = this.handleChange.bind(this);   
    }

    validateForm() {
        let errors = {};
        let formIsValid = true;

        if (this.state.username == '') {
            formIsValid = false;
            errors["Email"] = "* Required field";
        }
        else {
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(this.state.username)) {
                formIsValid = false;
                errors["Email"] = "* Please enter a valid email address.";
            }
        }

        this.setState({
            errors: errors
        });

        return formIsValid;
    }

    handleChange(event) {
        let setvalue = '';
        setvalue = event.target.value
        var self = this;
        self.setState({ [event.target.id]: setvalue });
    }

    ResetPassword() {
        let errors = {};
        if (this.validateForm()) {
            var email = this.refs["EmailAddress"].value;
            var self = this;

            var param = {
                Email: email
            }

            userService.postData('/User/ForgotPassword', param)
                .then(function (data) {
                    if (data == "Success") {
                        alert("Please check your inbox (or spam folder) to access your password and then login below.")
                        self.setState({ message: data });
                        self.setState({ redirectToLogin: true });
                    }
                    else {
                       // alert(data);
                        errors["Email"] = "* Please enter a valid email address.";
                        self.setState({
                            errors: errors
                        });

                    }
                });
        }
    }

    render() {
        const { user } = this.state;

        const meta = {
            title: "Kluwer Law Online - Forgot password",
            canonical: window.location.href,
        }

        if (this.state.redirectToLogin) {

            return <Redirect to={"/Login"} />
        }

        return (
            <DocumentMeta {...meta}>
            <div className="col-12">
                <div className="White">
                </div>
                <div className="White">
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="col-lg-12 BGGrey Loginhomepadding LoginHeight logintop">
                            <p className="LoginText PublicationTitle franziskafont"> Forgot password </p>
                            <p className="LoginText">Please enter the email address you have registered
                                for access to Kluwer Law Online and we will send
                                you an email to complete the process. </p>
                            <p className="LoginText">If you do not received an email please check your
                            spam folder or <Link to="/Feedback" className="LinkClass"> contact Customer Support</Link>.</p>
                            <p className="LoginText LoginSetright">
                                    <input className="form-control BookBody" type="text" value={this.state.username} name="username" ref="EmailAddress" placeholder="Please enter your email address" id="username" onChange={this.handleChange} />
                                    <div className="errorMsg">{this.state.errors.Email}</div>
                                </p>
                           
                            <p className="LoginText">
                                <div className="btn btn-info next" onClick={this.ResetPassword} role="button" >Get password</div>
                            </p>
                        </div>
                    </div>
                </div>
               
                <div className="White">
                </div>
                <div className="White">
                </div>
            </div >
                </DocumentMeta>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Login/ForgotPassword.jsx